import { Injectable } from '@angular/core';
import { doc, Firestore, setDoc, docData, updateDoc } from '@angular/fire/firestore';
import { take } from 'rxjs/operators';
import { User } from 'src/app/models/Users';
import { EntityService } from 'src/app/features/entity/services/entity.service';



const NavigatorKeys = [
  'fingerprint',
  'appCodeName',
  'appName',
  'appVersion',
  'language',
  'platform',
  'product',
  'productSub',
  'userAgent',
  'vendor',
  'vendorSub',
  'oscpu'
];

const ScreenKeys = [
  'availHeight',
  '​availLeft',
  '​availTop',
  '​availWidth',
  '​colorDepth',
  '​height',
  '​left',
  '​orientation',
  '​pixelDepth',
  '​top',
  '​width',
  '​mozOrientation'
];


@Injectable({
  providedIn: 'root'
})
export class FingerprintService {

  private _deviceInfo: {
    fingerprint: string,
    navigator: { [index: string]: any },
    screen: { [index: string]: any }
  };

  laoded = false;
  loading = false;

  user: User;

  constructor(
    private firestore: Firestore,
    private sEntity: EntityService
  ) { }

  init() {
    if (this.laoded) { return; }
    this.loading = true;
    this.calculateFingerPrint();
    this.verifyFingerPrint(this._deviceInfo.fingerprint);
    this.monitorUser();
    this.loading = false;
    this.laoded = true;
  }

  get device_info() {
    return this._deviceInfo;
  }

  get fingerprint() {
    return this._deviceInfo.fingerprint;
  }

  private monitorUser() {
    this.sEntity.user$.subscribe(user => {
      this.user = user;
      if (user) {
        this.saveLogin(user.id);
      }
    });
  }

  private saveOnUser(userID: number, data: any) {

    const refUser = doc(this.firestore, `entities/${userID}`);

    docData(refUser)
      .pipe(take(1))
      .subscribe(dbEntity => {
        if (!dbEntity) {
          setDoc(refUser, data);
        } else {
          updateDoc(refUser, data);
        }
      });
  }

  private saveOnDevice(userID: number, data: any) {
    const ref = doc(this.firestore, `entities/${userID}/devices/${this.device_info.fingerprint}`);
    docData(ref)
      .pipe(take(1))
      .subscribe(current => {
        if (!current) {
          setDoc(ref, data);
        } else {
          updateDoc(ref, data);
        }
      });
  }

  private verifyFingerPrint(fingerprint: string) {
    const current = localStorage.getItem('notification_fp');
    if (current) {
      this._deviceInfo.fingerprint = current;
      return;
    }
    const fp = fingerprint.padEnd(41, '0');
    localStorage.setItem('notification_fp', fp);
    this._deviceInfo.fingerprint = fp;
  }

  private calculateFingerPrint() {

    const navigatorInfo = window.navigator;
    const screenInfo = window.screen;
    let fingerprint = navigatorInfo.mimeTypes.length.toString();
    fingerprint += navigatorInfo.userAgent.replace(/\D+/g, '');
    fingerprint += navigatorInfo.plugins.length;
    fingerprint += screenInfo.height || '';
    fingerprint += screenInfo.width || '';
    fingerprint += screenInfo.pixelDepth || '';

    const navigator: { [index: string]: any } = {};
    for (const k in navigatorInfo) {
      if (NavigatorKeys.includes(k)) {
        navigator[k] = navigatorInfo[k];
      }
    }

    const screen: { [index: string]: any } = {};

    for (const y in screenInfo) {
      if (screenInfo.hasOwnProperty(y)) {
        const sType = typeof (screenInfo[y]);
        if (sType !== 'function' && sType !== 'object' && sType !== 'undefined') {
          screen[y] = screenInfo[y];
        }
      }
    }

    this._deviceInfo = {
      fingerprint,
      navigator,
      screen
    };
  }

  private generateUUID() {
    const date = new Date().getTime().toString();
    return date.padEnd(13, '0');
  }

  saveLogin(userID: number) {
    const data = {
      lastLogin: new Date().toISOString(),
      lastDevice: this.device_info.fingerprint
    };

    this.saveOnUser(userID, data);
    this.saveOnDevice(userID, {
      ...this.device_info,
      logged: true,
      loggedIn_date: new Date().toISOString()
    });
  }

  saveLogout(userID: number) {
    const data = {
      lastDevice: this.device_info.fingerprint
    };

    this.saveOnUser(userID, data);
    this.saveOnDevice(userID, {
      logged: false,
      loggedOut_date: new Date().toISOString()
    });
  }

}
